import React from 'react';
import strings from '../../../localization';
import Button from '@material-ui/core/Button';
import {getError, hasError} from "../../../functions/Validation";
import PasswordTextField from '../../controls/PasswordTextField';

const ResetPasswordForm = ({
                              onSubmit,
                              onChange,
                              errors,
                              data,
                              keyPress
                          }) => (
    <form id="login-form" onSubmit={ onSubmit } action = "#">
        <PasswordTextField
            label={ strings.resetPassword.password }
            error={ hasError(errors, 'password') }
            helperText={ getError(errors, 'password') }
            fullWidth
            autoFocus
            name='password'
            onChange={ onChange }
            onKeyPress={ keyPress }
            margin="normal"
            value={ data.password }
            variant='outlined'
        />

        <PasswordTextField
            label={ strings.resetPassword.passwordRepeat }
            error={ hasError(errors, 'passwordRepeat') }
            helperText={ getError(errors, 'passwordRepeat') }
            fullWidth
            name='passwordRepeat'
            onChange={ onChange }
            onKeyPress={ keyPress }
            margin="normal"
            value={ data.passwordRepeat }
            variant='outlined'
        />

        <div className='submit-container'>
            <Button variant="contained" color="primary" onClick={ onSubmit }>
                { strings.resetPassword.resetPassword }
            </Button>
        </div>
    </form>
);

export default ResetPasswordForm;
